import axios from "axios";
import { Component } from 'react';
import { Button, Card, Col, Form, Row, Spinner } from "react-bootstrap";
import DatePicker from 'react-datepicker';
import { validateAdvancePaymentForm } from '../../utils/validation';
import CommonLoader from '../loaderComponent/CommonLoader';
import CommonToast from '../Toaster/CommonToast';

export default class AddAdvancePayment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: "",
      amount: "",
      year: "",
      dateOfPayment: null,
      description: "",
      employeeList: [],
      month: "",
      loading: true,
      hasError: false,
      errMsg: "",
      completed: false,
      message: '',
      errors: {},
      showToast: false,
      toastMessage: '',
      toastVariant: '',
      color: ''
    };
  }

  pushEmployees = () => {
    return this?.state?.employeeList?.map((emp, index) => (
      <option key={index} value={emp?.id}>
        {emp?.fullName}
      </option>
    ));
  };

  // pushEmployees = () => {
  //   let empList = [];
  //   this?.state?.employeeList?.map((emp, index) => {
  //     empList.push(
  //       <option key={index} value={emp?.id}>
  //         {emp?.fullName}
  //       </option>
  //     );
  //   });
  //   return empList;
  // };

  async componentDidMount() {
    this.setState({ loading: true })
    const token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };

    try {
      const usersResponse = await axios.get("/users", headers);
      console.log("Users Response:", usersResponse);
      this.setState({ employeeList: usersResponse.data, loading: false });
    } catch (error) {
      console.error("Error fetching data:", error);
      this.setState({ hasError: true, errMsg: "Failed to load customers" });
      setTimeout(() => {
        this.setState({ loading: false, showToast: false });
        this.props.history.push('/login')
      }, 900);

    }
  }

  handleChange = (event) => {
    const { value, name } = event.target;
    let errors = { ...this.state.errors };


    if (name === "amount") {
      if (!/^\d{1,8}$/.test(value) && value !== "") {
        return;
      }
    }
    if (value.trim()) {
      delete errors[name];
    }
    this.setState({
      [name]: value,
      errors
    });
  };

  handleDateChange = (date, field) => {
    if (!date) return;
    const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);

    this.setState({
      [field]: localDate,
      errors: {
        ...this.state.errors,
        [field]: localDate ? undefined : `${field} is required`
      }
    });
    // if (field === "year") {
    //   this.setState({
    //     year: date.getFullYear(), // Extract only the year
    //     errors: {
    //       ...this.state.errors,
    //       year: date ? undefined : "Year is required"
    //     }
    //   });
    // } else if (field === "month") {
    //   this.setState({
    //     month: date.getMonth() + 1, // Extract only the month (0-based index)
    //     errors: {
    //       ...this.state.errors,
    //       month: date ? undefined : "Month is required"
    //     }
    //   });
    // } else {
    //   this.setState({
    //     [field]: date,
    //     errors: {
    //       ...this.state.errors,
    //       [field]: date ? undefined : `${field} is required`
    //     }
    //   });
    // }
  };


  onSubmit = async (e) => {

    this.setState({ loading: true })
    e.preventDefault();
    const errors = validateAdvancePaymentForm(
      this.state.amount,
      this.state.empid,
      this.state.description,
      this.state.dateOfPayment,
      this.state.type
      // this.state.year,
      // this.state.month
    );
    const token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    const advancePaymentData = {
      empid: this.state.empid,
      amount: parseInt(this.state.amount, 10),
      dateOfPayment: this.state.dateOfPayment ?
        this.state.dateOfPayment.toISOString().split("T")[0] : null,
      type: this.state.type,
      // year: this.state.year,
      // month: this.state.month,
      description: this.state.description,
    };
    if (Object.keys(errors).length > 0) {
      this.setState({ errors, loading: false });
      return;
    }
    // debugger
    try {
      console.log(advancePaymentData);
      await axios.post('/advancePayment/add', advancePaymentData, { headers });
      this.setState({
        completed: true,
        toastMessage: "Advance Payment created successfully!",
        toastVariant: 'success',
        color: 'green',
        showToast: true,
      });
      setTimeout(() => {
        this.setState({ loading: false, showToast: false });
        this.props.history.push("/advance-pay-list");
      }, 900);
    } catch (error) {
      if (error.response) {
        console.error('Error response from server:', error.response.data);
        const errorMessage = error.response.data.error;
        if (errorMessage === "Something went wrong.") {
          this.setState({
            hasError: true,
            errMsg: errorMessage,
            toastMessage: "Advance payment  not done!",
            toastVariant: 'danger',
            color: 'red',
            showToast: true,
          });
          setTimeout(() => {
            this.setState({ loading: false, showToast: false });
          }, 900);
        } else if (errorMessage === "Something went wrong.") {
          this.setState({
            hasError: true,
            errMsg: errorMessage,
            toastMessage: "Advance payment  not done!",
            toastVariant: 'danger',
            color: 'red',
            showToast: true,
          });
          setTimeout(() => {
            this.setState({ loading: false, showToast: false });
          }, 900);
        }
        else {
          this.setState({
            hasError: true,
            errMsg: errorMessage,
            toastMessage: "Advance payment  not done!",
            toastVariant: 'danger',
            color: 'red',
            showToast: true,
          });
          setTimeout(() => {
            this.setState({ loading: false, showToast: false });
          }, 900);
        }
      } else {
        console.error('Error creating project:', error.message);
        this.setState({ hasError: true, errMsg: "An unexpected error occurred." });
        setTimeout(() => {
          this.setState({ loading: false, showToast: false });
        }, 900);
      }
    }
  };

  handleBack = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.props.history.push("/advance-pay-list");
      this.setState({ loading: false });
    }, 500);
  }

  handleChangefortype = (event) => {

    const { value, name } = event.target;
    let errors = { ...this.state.errors };
    if (name === "type" && value.trim()) {
      delete errors.type;
    }
    this.setState({
      [name]: value,
      errors
    });
  };

  render() {
    return (
      <div className=" container-fluid pt-4">
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />
        <CommonLoader isLoading={this.state.loading}>
          < >
            <Card className="shadow-sm rounded border-0">
              <Card.Header className="text-white"><strong>Add Advance Pay</strong></Card.Header>
              <Card.Body>
                {this.state.loading ? (
                  <div className="text-center">
                    <Spinner animation="border" variant="outline-primary" className="loader" />
                  </div>
                ) : (
                  <Form onSubmit={this.onSubmit}>
                    <Row className="mb-3">
                      <Col xs={12} md={3} lg={3}>
                        <Form.Group controlId="formDepartmentName">
                          <Form.Label className="required">
                            Type
                          </Form.Label>
                          <Form.Control
                            as="select"
                            className="form-select"
                            name="type"
                            value={this.state.type}
                            onChange={this.handleChangefortype}
                          >
                            <option value="">Choose one</option>
                            <option value="Salary Advance">Salary Advance </option>
                            <option value="Site Expense">Site Expense</option>
                          </Form.Control>
                        </Form.Group>
                        <span className="login-error">
                          {this.state.errors.type && <small className="text-danger">{this.state.errors.type}</small>}
                        </span>
                      </Col>
                      <Col xs={12} md={3} lg={3}>
                        <Form.Group>
                          <Form.Label className="text-muted required">Amount</Form.Label>
                          <Form.Control type="text" name="amount" size="md" value={this.state.amount} onChange={this.handleChange}
                            placeholder='Enter amount'
                          />
                        </Form.Group>
                        <span className="login-error">
                          {this.state.errors.amount && <small className="text-danger">{this.state.errors.amount}</small>}
                        </span>
                      </Col>
                      <Col xs={12} md={3} lg={3}>
                        <Form.Group>
                          <Form.Label className="text-muted required">Employee</Form.Label>
                          <Form.Control
                            as="select"
                            className="form-select"
                            value={this.state.empid}
                            onChange={this.handleChange}
                            name="empid"
                          >
                            <option value="" defaultValue>
                              Choose Employee
                            </option>
                            {this.pushEmployees()}
                          </Form.Control>
                        </Form.Group>
                        <span className="login-error">
                          {this.state.errors.empid && <small className="text-danger">{this.state.errors.empid}</small>}
                        </span>
                      </Col>
                      <Col xs={12} md={3} lg={3}>
                        <Form.Group>
                          <Form.Label className="text-muted required">Date Of Payment </Form.Label><br />
                          <DatePicker
                            selected={this.state.dateOfPayment}
                            className="form-control"
                            onChange={date => this.handleDateChange(date, 'dateOfPayment')}
                            placeholderText="Select Date Of Payment"
                          />
                          <span className="login-error">
                            {this.state.errors.dateOfPayment && <small className="text-danger">{this.state.errors.dateOfPayment}</small>}
                          </span>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col xs={12} md={6} lg={6}>
                        <Form.Group>
                          <Form.Label className="text-muted required">Description</Form.Label>
                          <Form.Control as="textarea" rows={1} name="description" value={this.state.description} onChange={this.handleChange}
                            placeholder='Enter description'
                          />
                        </Form.Group>
                        <span className="login-error">
                          {this.state.errors.description && <small className="text-danger">{this.state.errors.description}</small>}
                        </span>
                      </Col>
                    </Row>
                    {/* <Form.Group>
                    <Form.Label className="text-muted required">Year</Form.Label><br />
                    <DatePicker
                      selected={this.state.year ? new Date(this.state.year, 0) : null}
                      className="form-control"
                      onChange={date => this.handleDateChange(date, 'year')}
                      placeholderText="Select Year"
                      showYearPicker
                      dateFormat="yyyy"
                    />
                  </Form.Group>
                  <span className="login-error">
                    {this.state.errors.year && <small className="text-danger">{this.state.errors.year}</small>}
                  </span> */}
                    {/* <Form.Group>
                    <Form.Label className="text-muted required">Month</Form.Label><br />
                    <DatePicker
                      selected={this.state.month ? new Date(this.state.year, this.state.month - 1) : null}
                      className="form-control"
                      onChange={date => this.handleDateChange(date, 'month')}
                      placeholderText="Select Month"
                      showMonthYearPicker
                      dateFormat="MM/yyyy"
                    />
                  </Form.Group>
                  <span className="login-error">
                    {this.state.errors.month && <small className="text-danger">{this.state.errors.month}</small>}
                  </span> */}

                    <div className='add-cancel-btn '>
                      <Button type="submit"
                        variant='primary' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary">
                        Add
                      </Button>
                      <Button variant='danger' className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel" onClick={this.handleBack}>Cancel</Button>
                    </div>
                  </Form>
                )}
              </Card.Body>
            </Card>
          </>
        </CommonLoader >
      </div >
    );
  }
}
